import { MappedProductGroup } from '../../../../../store/api';
import zipWith from 'lodash/zipWith';

export const PRODUCT_GROUP_MAX_HEIGHT = 900;
const PRODUCT_GROUP_HEIGHT = 410;
const PRODUCT_GROUP_MARGIN_BOTTOM = 200;
const PRODUCT_GROUP_HEIGHT_EMPTY = 200;
const PRODUCT_GROUP_HEIGHT_EMPTY_BUFFER = 60;

export const calculateTopValues = (productGroups: MappedProductGroup[] = []) => {
    if (productGroups.length === 0) {
        return {};
    }

    const emptyGroupHeight = PRODUCT_GROUP_HEIGHT_EMPTY + PRODUCT_GROUP_HEIGHT_EMPTY_BUFFER;
    const groupHeight = PRODUCT_GROUP_HEIGHT + PRODUCT_GROUP_MARGIN_BOTTOM;

    const mapTopValuesByEmptyStates = emptyStateArray =>
        emptyStateArray.map((isProductGroupEmpty, _i) => {
            if (_i === 0) {
                return '0';
            } else if (_i === 1) {
                const isFirstItemEmpty = emptyStateArray[0];
                return isFirstItemEmpty ? `${emptyGroupHeight}px` : `${groupHeight}px`;
            } else if (_i === 2) {
                const isFirstItemEmpty = emptyStateArray[0];
                const isSecondItemEmpty = emptyStateArray[1];

                const areFirstTwoGroupsEmpty = isFirstItemEmpty && isSecondItemEmpty;
                const isOneOfTheFirstTwoGroupsEmpty = isFirstItemEmpty || isSecondItemEmpty;

                return areFirstTwoGroupsEmpty
                    ? `${2 * emptyGroupHeight}px`
                    : isOneOfTheFirstTwoGroupsEmpty
                    ? `${emptyGroupHeight + groupHeight}px`
                    : `${2 * groupHeight}px`;
            }
            return undefined;
        });

    const heightWithEmptyFlags = productGroups.map(productGroup => {
        const productsAmount = productGroup.products?.length ?? 0;
        const isProductGroupEmpty = productsAmount === 0;
        const height = isProductGroupEmpty
            ? PRODUCT_GROUP_HEIGHT_EMPTY
            : PRODUCT_GROUP_HEIGHT + PRODUCT_GROUP_MARGIN_BOTTOM;

        return { height, isProductGroupEmpty };
    });

    const topValues = mapTopValuesByEmptyStates(heightWithEmptyFlags.map(group => group.isProductGroupEmpty));

    const resultObjectsArray = zipWith(heightWithEmptyFlags, topValues, function (productGroupObject, top) {
        return { ...productGroupObject, top };
    });

    const reducer = (accumulator, item) => accumulator + item.height;
    const wrapperHeight = resultObjectsArray.reduce(reducer, 0);
    return {
        ...resultObjectsArray,
        wrapperHeight
    };
};
